/** The key-hint bar along the bottom of every screen (08 §5.5: the keyboard is never a guess). */

import { el } from '../dom';

export interface KeyHint {
  keys: string;
  label: string;
}

export const NAV_HINTS: readonly KeyHint[] = [
  { keys: 'ARROWS', label: 'MOVE' },
  { keys: 'ENTER', label: 'SELECT' },
  { keys: 'ESC', label: 'BACK' },
];

/** The same, where Esc leads nowhere (title) or something other than "back". */
export function navHints(escLabel: string | null): KeyHint[] {
  const hints = NAV_HINTS.slice(0, 2);
  if (escLabel !== null) hints.push({ keys: 'ESC', label: escLabel });
  return hints;
}

export function keyHintBar(hints: readonly KeyHint[], note = ''): HTMLElement {
  const bar = el('div', 'menu-hints');
  for (const hint of hints) {
    const item = el('span', 'menu-hint');
    item.append(el('span', 'menu-key', hint.keys), el('span', '', hint.label));
    bar.append(item);
  }
  if (note !== '') bar.append(el('span', 'menu-hints-note', note));
  return bar;
}
